import { BreadcrumbsItem } from '@atlaskit/breadcrumbs';
import { Stack, Text } from '@atlaskit/primitives';
import Placeholder from '@atlaskit/react-ufo/placeholder';
import Spinner from '@atlaskit/spinner';
import { useTenantData } from '@dev-agents/tenant-context';
import { useEffect } from 'react';
import { useIntl } from 'react-intl-next';
import { useQueryLoader } from 'react-relay';

import { PageSection } from '../../../../common/components/page-section';
import { settingsCodePlannerPath } from '../../../../routes/paths';
import { RovoDevAgentsPageHeader } from '../../components/rovo-dev-agents-page-header';
import type { codePlannerConfigurationQuery } from '../components/__generated__/codePlannerConfigurationQuery.graphql';
import query from '../components/__generated__/codePlannerConfigurationQuery.graphql';
import { CodePlannerConfiguration } from '../components/code-planner-configuration';

import messages from './messages';
import { jiraProjectAdministorProjectsJql } from './types';

export const CodePlannerSettings = () => {
	const { tenantContexts } = useTenantData();
	const { cloudId } = tenantContexts[0];
	const { formatMessage } = useIntl();

	const [queryRef, loadQuery] = useQueryLoader<codePlannerConfigurationQuery>(query);

	useEffect(() => {
		if (!queryRef) {
			loadQuery({ cloudId, query: jiraProjectAdministorProjectsJql });
		}
	}, [queryRef, loadQuery, cloudId]);

	const loadingState = () => {
		return (
			<Stack alignInline="center" space="space.300">
				<Spinner size="large" />
				<Text>{formatMessage(messages.pageLoadingMessage)}</Text>
			</Stack>
		);
	};

	return (
		<PageSection>
			<Stack space="space.400">
				<RovoDevAgentsPageHeader
					additionalBreadcrumbItems={[
						<BreadcrumbsItem
							href={`/dev-agents${settingsCodePlannerPath}`}
							text={formatMessage(messages.breadCrumbTitle)}
							key="code-planner"
						/>,
					]}
					headingText={formatMessage(messages.breadCrumbTitle)}
					descriptionText={formatMessage(messages.pageDescription)}
				/>
				<Placeholder name="dev-agents-code-planner-settings" fallback={loadingState()}>
					{queryRef && <CodePlannerConfiguration queryRef={queryRef} />}
				</Placeholder>
			</Stack>
		</PageSection>
	);
};
